import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as traclink from '@webapp/sdk/traclink';
import { Action } from 'redux';
import {
  DeleteTourEvent,
  DeleteTourEventSuccess,
  DeleteTourEventError,
} from '../action-creators';
import { DELETE_TOUR_EVENT } from '../actions';

export const DeleteTourEventEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, DeleteTourEvent>(DELETE_TOUR_EVENT),
    mergeMap(async (action) => {
      try {
        const data = await traclink.deleteTourEvent(
          action.ownerId,
          action.tourId
        );
        if (data.success) {
          return new DeleteTourEventSuccess(action.tourId);
        } else {
          return new DeleteTourEventError('TOUREVENT.FAILURE_RESPONSE');
        }
      } catch (err) {
        return new DeleteTourEventError(err.message);
      }
    })
  );
